import { render, staticRenderFns } from "./forex-tools.vue?vue&type=template&id=87c40f00&scoped=true"
import script from "./forex-tools.vue?vue&type=script&lang=js"
export * from "./forex-tools.vue?vue&type=script&lang=js"
import style0 from "./forex-tools.vue?vue&type=style&index=0&id=87c40f00&prod&lang=css"
import style1 from "./forex-tools.vue?vue&type=style&index=1&id=87c40f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c40f00",
  null
  
)

export default component.exports